/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Indlæser...',
	'dlg_close': 'Luk',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annullér',
	'dlg_back': 'Gå tilbage',
	'dlg_done': 'Udført',
	'dlg_save': 'Gem',

	// Slider
	'sliderRegionLabel': 'Skyderkontrol, brug højre og venstre pil til at flytte skyderhåndtagene',
	'sliderHandleLabel': 'Skyderhåndtag',
	'a11ySliderHandleLabel': 'Skyderhåndtag %{sliderValue}',
	'sliderInputLabel': 'værdi',

	// Side bar
	'sidebarAdd': 'Tilføj',
	'clearTextFilterValue': 'Ryd',
	'missingDataSetData': 'Data til dette datasæt er ikke tilgængelige. Opfrisk datasættet, eller kontakt administratoren for at få adgang til kilden.',

	// Toolbar
	'toolbarRegionLabel': 'Værktøjslinje',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Fontserie',
	'fontFamilyStyle': 'Skrifttype',
	'regularFontStyle': 'Almindelig',
	'fontSizeSelect': 'Fontstørrelse',
	'fontColorSelect': 'Farve',
	'fontStyle': 'Typografi',
	'colorPickerTitle': 'Vælg en farve',
	'bold': 'Fed',
	'italic': 'Kursiv',
	'underline': 'Understreget',
	'fontAlignment': 'Justering',
	'justifyLeft': 'Justér til venstre',
	'justifyCenter': 'Justér centreret',
	'justifyRight': 'Justér til højre',
	'insertOrderedList': 'Sorteret liste',
	'insertUnorderedList': 'Usorteret liste',
	'fontColorPicker': 'Farvevælger',
	'textWrap': 'Tekstomløb',
	'restore': 'Gendan standardværdier',
	'textAutoFontSize': 'Automatisk',
	'textDefaultFontSize': 'Standard',
	'textItemTitle': 'Titel',
	'textLabelShadow': 'Etiket skygge',
	'textContrastLabelColor':'Kontrastfarve',
	'toggleOn': 'Aktiveret',
	'toggleOff': 'Deaktiveret',
	'contrastLabelColorInfo': 'Juster automatisk etiketfarve for tilgængelighed. Dette tilsidesætter farven på skrifttypen.',
	'labelShadowInfo':'Tilføj skygger til teksten for tilgængelighed.',
	'applyToAll':'Anvend typografi på alle akser',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Antal resultater (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Procent (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Øverste eller nederste - indstilling',
	'topbottomOptionLabel': 'Vis',
	'searchByLabel': 'Efter',
	'searchNoMatches': 'Ingen forekomster fundet',
	'topbottomRankColumnLabel': 'Tilføj en prioriteringskolonne til tabellen',
	'topbottomNone': 'Ingen',
	'topCount': 'Øverste antal',
	'topPercent': 'Øverste  %',
	'bottomCount': 'Nederste antal',
	'bottomPercent': 'Nederste  %',
	'searchColumn': 'Søg efter en kolonne',
	'searchColumnAriaLabel': 'Søg efter en kolonne. Skriv navnet på den kolonne, du vil søge efter, og brug derefter pil ned til at finde kolonnen på listen.',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Prioritet (%{columnLabel})',
	'topbottomClearLabel': 'Nulstil',

	// Format
	'formatAuto': 'Automatisk',
	'formatConvertPercent': 'Konvertér decimal til procent',
	'formatAbbreviate': 'Forkort',
	'formatUseGrouping': 'Brug tusindtalsskilletegn',
	'dateStyle': 'Datotypografi',
	'dateTimeStyle': 'Dato-/klokkeslætstypografi',
	'formatMissingValueCharactersInfo': 'Tegn for manglende værdi angiver de tegn, der skal vises, når værdien mangler.',
	'currencySymbolLabel': 'Valutasymbol',
	'customSymbolPlaceholder': 'Tilføj et symbol',
	'customSymbolLabelInfo': 'Angiver et eller flere tegn, der skal bruges som et tilpasset symbol. Symbolet vil stå foran tallet og et vilkårligt tegn.',
	'numberLabel': 'Taletiket',
	'numberPositionLabel': 'Etiketplacering',
	'negativeSignPosition': 'Placering af negativsymbol',
	'negativeSign': 'Negativsymbol',
	'numberLabelInfo': 'Angiver en etiket til et formateret tal og placeres som præfiks eller suffiks afhængigt af etiketplaceringen.',
	'nullValueDefault': '<standard>',
	'nullValueContent': '(ingen værdi)',
	'default': 'Standard',
	'beginning': 'Begyndelse',
	'end': 'Slut',
	'formatLabel': 'Vælg et format',

	// More data indicator
	'moreDataIndicator': 'Data blev afkortet ved %{threshold} elementer. Anvend et filter for at få vist færre.',

	// Expanded View / Focus mode
	'evCollapse': 'Skjul',
	'duplicate': 'Duplikér',
	'copyOf': 'Kopi af %{name}',
	'unableToDuplicateBoard': 'Kan ikke duplikere "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Objekterne kan ikke indlæses.',

	// Custom widgets
	'customWidget': 'Tilpasset widget',

	// Auto group
	'group': 'Gruppe',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Fin streg',
	'textFontFamilySubClassThin': 'Tynd',
	'textFontFamilySubClassThinItalic': 'Tynd kursiv',
	'textFontFamilySubClassExtraLight': 'Ekstra let',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra let kursiv',
	'textFontFamilySubClassLight': 'Lys',
	'textFontFamilySubClassLightItalic': 'Let kursiv',
	'textFontFamilySubClassRegular': 'Almindelig',
	'textFontFamilySubClassRegularItalic': 'Almindelig kursiv',
	'textFontFamilySubClassItalic': 'Kursiv',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium kursiv',
	'textFontFamilySubClassHeavy': 'Kraftig',
	'textFontFamilySubClassHeavyItalic': 'Kraftig kursiv',
	'textFontFamilySubClassDemiBold': 'Halvfed',
	'textFontFamilySubClassDemiBoldItalic': 'Halvfed kursiv',
	'textFontFamilySubClassBold': 'Fed',
	'textFontFamilySubClassBoldItalic': 'Fed Kursiv',
	'textFontFamilySubClassExtraBold': 'Ekstra fed',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra fed kursiv',
	'textFontFamilySubClassBlack': 'Sort',
	'textFontFamilySubClassBlackItalic': 'Sort kursiv',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass
});
